import { configureStore } from '@reduxjs/toolkit'
import layoutReducer from "./Layout/layoutSlice"
import AdminReducer from "./Admin/AdminSlice"
import NotifReducer from './Notif/NotifSlice'

export const store = configureStore({
  reducer: {
    layout : layoutReducer,
    Admin : AdminReducer,
    Notif : NotifReducer,
  },
})